import React, { useState, useEffect } from 'react';
import { getcampaignbylead } from "../components/api2";
import AllCamp from '../pages/allCampaign';
import axios from 'axios';
import { Config } from '../.env.js';

const ITEMS_PER_PAGE = 10;
const PAGES_DISPLAYED = 5;

const LiveLead = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loggedInUserName, setLoggedInUserName] = useState('');

    useEffect(() => {
        const fetchCampaigns = async () => {
            const storedUserName = localStorage.getItem("loggedInUserName");
            if (!storedUserName) {
                console.error("No loggedInUserName found in localStorage");
                return;
            }

            setLoggedInUserName(storedUserName);

            try {
                const response = await axios.get(
                    `${Config.API_URL}/api/ready-campaigns`,
                    {
                        params: {
                            leadName: storedUserName,
                        },
                    }
                );

                const allCampaigns = response.data;

                const leadCampaigns = allCampaigns
                    .filter(campaign =>
                        campaign.leads?.some(m => m.toLowerCase() === storedUserName.toLowerCase())
                    )
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // sort by newest

                setCampaigns(leadCampaigns);
            } catch (error) {
                console.error('Error fetching campaigns:', error);
            }
        };

        fetchCampaigns();
    }, []);

    const totalPages = Math.ceil(campaigns.length / ITEMS_PER_PAGE);
    const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
    const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
    const paginatedCampaigns = campaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className='container'>
            <h1 className='title is-1 has-text-centered'><b>Brand Collabs For You</b></h1>
            <h2 className='subtitle is-3 has-text-centered'>BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>
            <div className="columns is-multiline is-centered">
                {paginatedCampaigns.length > 0 ? (
                    paginatedCampaigns.map((campaign, index) => (
                        <div
                            key={campaign._id || index}
                            className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
                        >
                            <AllCamp campaign={campaign} alignLeft={index % 2 === 0} />
                        </div>
                    ))
                ) : (
                    <div className="has-text-centered">No campaigns to display</div>
                )}
            </div>

            <div className="pagination is-centered" role="navigation" aria-label="pagination">
                {currentPage > 1 && (
                    <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                )}
                {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                    <button
                        key={page}
                        className={`pagination-link ${page === currentPage ? 'is-current' : ''}`}
                        aria-label={`Goto page ${page}`}
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {currentPage < totalPages && (
                    <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                )}
            </div>
        </div>
    );
};

export default LiveLead